import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import { RefObject, useLayoutEffect } from 'react';
import { gsap, SplitText } from '@/lib/gsap';
import css from './style.module.scss';
export const useReveal = wrapperRef => {
  const $ = _c(6);
  let t0;
  let t1;
  if ($[0] !== wrapperRef) {
    t0 = () => {
      if (!wrapperRef.current) {
        return;
      }
      gsap.fromTo(wrapperRef.current, {
        y: 50,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: wrapperRef.current,
          start: "top 90%",
          toggleActions: "play none none reverse"
        }
      });
    };
    t1 = {
      scope: wrapperRef
    };
    $[0] = wrapperRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useGSAP(t0, t1);
  let t2;
  let t3;
  if ($[3] !== wrapperRef) {
    t2 = () => {
      let cancelled = false;
      let ctx = null;
      let split = null;
      const run = async () => {
        await (document.fonts?.ready ?? Promise.resolve());
        if (cancelled) {
          return;
        }
        const titleText = wrapperRef.current?.querySelector(`.${css.title}`);
        if (!titleText) {
          return;
        }
        const splitInstance = new SplitText(titleText, {
          type: "lines",
          linesClass: css.line,
          mask: "lines"
        });
        split = splitInstance;
        ctx = gsap.context(() => {
          gsap.matchMedia().add({
            isDesktop: "(min-width: 992px)",
            isMobile: "(max-width: 991px)"
          }, context => {
            const {
              isMobile
            } = context.conditions as gsap.Conditions;
            if (isMobile) {
              gsap.set(titleText, {
                opacity: 1
              });
              return;
            }
            gsap.set(splitInstance.lines, {
              yPercent: 100,
              opacity: 0
            });
            gsap.set(titleText, {
              opacity: 1
            });
            gsap.to(splitInstance.lines, {
              yPercent: 0,
              opacity: 1,
              duration: 0.6,
              ease: "power2.out",
              stagger: {
                each: 0.06,
                from: "start"
              },
              scrollTrigger: {
                trigger: titleText,
                start: "top bottom",
                end: "bottom 90%",
                toggleActions: "play none none reverse"
              }
            });
          });
        }, titleText);
      };
      run();
      return () => {
        cancelled = true;
        ctx?.revert();
        split?.revert();
      };
    };
    t3 = [wrapperRef];
    $[3] = wrapperRef;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useLayoutEffect(t2, t3);
};